import { render, staticRenderFns } from "./dashboard-storage-low-rank.vue?vue&type=template&id=3c93d6e8&scoped=true&"
import script from "./dashboard-storage-low-rank.vue?vue&type=script&lang=js&"
export * from "./dashboard-storage-low-rank.vue?vue&type=script&lang=js&"
import style0 from "./dashboard-storage-low-rank.vue?vue&type=style&index=0&id=3c93d6e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c93d6e8",
  null
  
)

export default component.exports